import { useEffect } from "react";
import { connect } from "react-redux";
import { Field, reduxForm, formValueSelector } from "redux-form";
import { Button, Checkbox, Select } from "expano-components";
import { Main } from "layouts";
import { getUser, updateUser } from "actions/users";

import packer_gauge_options from "utils/packer_gauge_options";
import { user_role_options_text } from "utils/user_role_options";
import { work_mode_options_text } from "utils/work_mode_options";
import { settlement_type_options } from "utils/settlement_type_options";

import { ReactComponent as InfoIcon } from "icons/info.svg";
import { ReactComponent as UserIcon } from "icons/user.svg";

import PieceworkerRatesCard from "./components/PieceworkerRatesCard";
const editUserFormSelector = formValueSelector("edit-user");

const SelectField = (props) => <Select {...props} />;
const CheckField = (props) => <Checkbox {...props} />;

const UserEdit = ({
  submitting,
  pristine,
  change,
  handleSubmit,
  match: {
    params: { id },
  },
  user,
  isPieceworker,
  getUser,
  updateUser,
}) => {
  useEffect(() => {
    getUser(id);
  }, [id]);

  const onSubmit = (values) => updateUser(id, values);

  return (
    <Main
      is_loading={["invalid", "loading", "failure"].includes(user.status)}
      page={{
        name: user.data?.full_name,
        icon: <UserIcon />,
        breadcrumbs: [
          {
            name: "Użytkownicy",
            path: "/users",
          },
          { name: user.data?.full_name },
        ],
      }}
    >
      <div className="dashboard-wrapper-flex m-t-10">
        <div className="column-half">
          <form
            noValidate
            onSubmit={handleSubmit(onSubmit)}
            className="dashboard"
          >
            <header className="dashboard__header">
              <div className="icon__container">
                <InfoIcon />
              </div>
              <h2 className="dashboard__title heading">Podstawowe dane</h2>
            </header>
            <div className="dashboard__form p-t-20">
              <div className="dashboard-wrapper-flex m-b-20">
                <div className="column-half">
                  <Field
                    name="role"
                    label="Rola"
                    component={SelectField}
                    options={user_role_options_text}
                    handleChange={(value) => change("role", value)}
                    defaultValue={user_role_options_text.find(
                      ({ value }) => value === user.data?.role,
                    )}
                  />
                </div>
                <div className="column-half">
                  <Field
                    name="packer_gauge"
                    label="Gabaryt pakowacza"
                    component={SelectField}
                    options={packer_gauge_options}
                    handleChange={(value) => change("packer_gauge", value)}
                    defaultValue={packer_gauge_options.find(
                      ({ value }) => value === user.data?.packer_gauge,
                    )}
                  />
                </div>
              </div>
              <div className="dashboard-wrapper-flex">
                <div className="column-half">
                  <Field
                    name="work_mode"
                    label="Tryb pracy"
                    component={SelectField}
                    options={work_mode_options_text}
                    handleChange={(value) => change("work_mode", value)}
                    defaultValue={work_mode_options_text.find(
                      ({ value }) => value === user.data?.work_mode,
                    )}
                  />
                </div>
                <div className="column-half">
                  <Field
                    name="is_pieceworker"
                    label="Typ rozliczenia"
                    component={SelectField}
                    options={settlement_type_options}
                    handleChange={(value) => change("is_pieceworker", value)}
                    defaultValue={settlement_type_options.find(
                      ({ value }) => value === Boolean(user.data?.is_pieceworker),
                    )}
                  />
                </div>
              </div>
              <div className="dashboard-wrapper-flex">
                <div className="column-half">
                  <Field
                    name="is_working_from_office"
                    label="Pracownik biurowy"
                    component={CheckField}
                  />
                </div>
              </div>
              <div className="dashboard-wrapper-flex">
                <div className="column-half">
                  <Field
                    name="disabled_difficult_positions"
                    label="Blokada trudnych lokalizacji"
                    component={CheckField}
                  />
                </div>
              </div>
              <div className="dashboard-wrapper-flex">
                <div className="column-half">
                  <Field
                    name="can_skip_scan_product_in_grn"
                    label="Przyjmowanie dostaw bez skanowania"
                    component={CheckField}
                  />
                </div>
              </div>
              <div className="dashboard-wrapper-flex">
                <div className="column-half">
                  <Field
                    name="can_confirm_picker_missings"
                    label="Potwierdzanie braków pikera"
                    component={CheckField}
                  />
                </div>
              </div>
              <div className="dashboard-wrapper-flex">
                <div className="column-half">
                  <Field
                    name="can_inventorize_from_warehouse_task"
                    label="Możliwość inwentaryzacji z poziomu zadania magazynowego"
                    component={CheckField}
                  />
                </div>
              </div>
              <div className="dashboard-wrapper-flex">
                <div className="column-half">
                  <Field
                    name="can_show_real_stock_details"
                    label="Dostęp do szczegółów stanów magazynowych"
                    component={CheckField}
                  />
                </div>
              </div>
              <div className="dashboard-wrapper-flex">
                <div className="column-half">
                  <Field
                    name="can_inventorize_heavy"
                    label="Może inwentaryzować cięzkie pozycje?"
                    component={CheckField}
                  />
                </div>
              </div>
              <div className="dashboard-wrapper-flex">
                <div className="column-half">
                  <Field
                    name="can_show_product_sales"
                    label="Dostęp do ilości sprzedaży"
                    component={CheckField}
                  />
                </div>
              </div>
              <div className="dashboard-wrapper-flex">
                <div className="column-half">
                  <Field
                    name="can_scan_qr_in_grn"
                    label="Navigator - możliwość skanowania QR podczas przyjmowania dostawy"
                    component={CheckField}
                  />
                </div>
              </div>
              <div className="dashboard-wrapper-flex">
                <div className="column-half">
                  <Field
                    name="can_show_locations_in_navigator_grn_lines"
                    label="Navigator - możliwość wyświetlenia lokalizacji na liście pozycji dostawy"
                    component={CheckField}
                  />
                </div>
              </div>
              <div className="dashboard-wrapper-flex">
                <div className="column-half">
                  <Field
                    name="can_balance_warehouse_diffs"
                    label="Mozliwość wyrównania różnic magazynowych"
                    component={CheckField}
                  />
                </div>
              </div>
            </div>
            <div className="dashboard__form__footer">
              <Button
                disabled={pristine || submitting}
                type="save"
                text="Zapisz"
                onClick={handleSubmit(onSubmit)}
              />
            </div>
          </form>
        </div>
        {isPieceworker && user.data?.id ? (
          <PieceworkerRatesCard userId={user.data.id} />
        ) : null}
      </div>
    </Main>
  );
};

export default connect(
  (state) => ({
    user: state.user,
    isPieceworker: Boolean(
      editUserFormSelector(state, "is_pieceworker") ??
      state.user.data?.is_pieceworker,
    ),
    initialValues: {
      role: state.user.data?.role,
      packer_gauge: state.user.data?.packer_gauge,
      is_working_from_office: state.user.data?.is_working_from_office,
      is_pieceworker: state.user.data?.is_pieceworker,
      disabled_difficult_positions:
        state.user.data?.disabled_difficult_positions,
      work_mode: state.user.data?.work_mode,
      can_skip_scan_product_in_grn:
        state.user.data?.can_skip_scan_product_in_grn,
      can_confirm_picker_missings: state.user.data?.can_confirm_picker_missings,
      can_inventorize_from_warehouse_task:
        state.user.data?.can_inventorize_from_warehouse_task,
      can_show_real_stock_details: state.user.data?.can_show_real_stock_details,
      can_inventorize_heavy: state.user.data?.can_inventorize_heavy,
      can_show_product_sales: state.user.data?.can_show_product_sales,
      can_scan_qr_in_grn: state.user.data?.can_scan_qr_in_grn,
      can_show_locations_in_navigator_grn_lines:
        state.user.data?.can_show_locations_in_navigator_grn_lines,
      can_balance_warehouse_diffs: state.user.data?.can_balance_warehouse_diffs,
    },
  }),
  (dispatch) => ({
    getUser: (id) => dispatch(getUser(id)),
    updateUser: (id, values) => dispatch(updateUser(id, values)),
  }),
)(
  reduxForm({
    form: "edit-user",
    enableReinitialize: true,
  })(UserEdit),
);
